module.exports = __webpack_public_path__ + "img/backup-ps.c7df8f3f.png";